import React, { createContext, useContext, useEffect, useState } from "react";
import { whoAmI } from "../server/server";

const UserContext = createContext<any>(undefined);

const UserProvider = (props: any) => {
  const _user = JSON.parse(localStorage.getItem("user") || "{}");
  const [user, setUser] = useState(_user);
  const isSignedIn = !!user.email;

  useEffect(() => {
    const refreshUser = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token || !_user?.email) return;

      const response = await whoAmI();
      if (response?.status === 200) {
        const freshData = response.data;
        const currentRoleName = _user?.roleView?.name;
        const freshRole = freshData?.roles?.find(
          (r: any) => r.name === currentRoleName,
        );
        if (freshRole) {
          const updatedUser = { ...freshData, roleView: freshRole };
          setUser(updatedUser);
          localStorage.setItem("user", JSON.stringify(updatedUser));
        }
      }
    };
    refreshUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, isSignedIn }} {...props} />
  );
};

function useUser() {
  const context = useContext(UserContext);

  if (context === undefined) {
    throw new Error(`useUser must be used within a UserProvider`);
  }

  return context;
}

export { UserProvider, useUser };
